import { render, staticRenderFns } from "./SweetAlertOption.vue?vue&type=template&id=740ec42e&"
import script from "./SweetAlertOption.vue?vue&type=script&lang=js&"
export * from "./SweetAlertOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports